"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VotingOption = exports.DefaultBasicFeeGrantOption = void 0;
exports.DefaultBasicFeeGrantOption = { spendLimit: undefined, expiration: undefined };
var VotingOption;
(function (VotingOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */
    VotingOption[VotingOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */
    VotingOption[VotingOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */
    VotingOption[VotingOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */
    VotingOption[VotingOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */
    VotingOption[VotingOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VotingOption[VotingOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(VotingOption = exports.VotingOption || (exports.VotingOption = {}));
